import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AlertService, MessageDetail } from '../components/shared/alert/alert.service';



@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {

    constructor(private alertService: AlertService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const loginPath = 'login';
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    console.log(error);

                    if (error.error && error.error.error == "ValidationException") {
                        this.alertService.addErrors('Validazione campi', ['Campi non corretamente compilati'], true);
                    }
                    else if (error.error && error.error.error == "ServiceException") {
                        if (error.error.messages) {
                            let messages: MessageDetail[] = [];
                            error.error.messages.forEach((err: any) => {
                                messages.push(this.computeServiceException(err))
                            });
                            this.alertService.addApiErrors('Errore', messages, true);
                        }
                        else {
                            this.alertService.addErrors('Errore', ['Errore. Riprovare'], true);
                        }

                    }
                    else {
                        this.alertService.addErrors('Errore', ['Errore. Riprovare'], true);
                    }
                    return throwError(() => error);
                })
            )
    }

    private computeServiceException(message: any) {

        let messageToReturn: MessageDetail = {};
        if (message.message && message.message == 'OBJECT_DUPLICATED') {
            messageToReturn.message = 'Oggetto duplicato';
            messageToReturn.detail = message.detail ?? ' N/D';
            return messageToReturn;
        } else if (message.message && message.message == 'OBJECT_LINKED') {
            messageToReturn.message = 'Oggetto utilizzato.';
            messageToReturn.detail = message.detail ?? ' N/D';
            return messageToReturn;
        } else if (message.message && message.message == 'INVALID_TS_UPLOAD_DATA') {
            messageToReturn.message = 'Attenzione! File contiene record con date sifferenti dal servizio selezionato';
            messageToReturn.detail = message.detail;
            return messageToReturn;
        }

        return <MessageDetail>{ message: 'Errore. Riprovare' }
    }

}